// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","513":"482e7fdc","706":"cc727622","827":"ba0d6914","962":"51354ad0"}[chunkId] + ".chunk.js";
};